import { Center, Container, Image, SimpleGrid, Text, Title } from '@mantine/core';
import image from '../../assets/images/no-network.jpg';
import classes from './index.module.css';
import { Translate } from 'react-auto-translate';

/*
  * No Network Page
*/
function PageNoNetwork() {
  return (
		<Container className={classes.root}>
			<Center w="100%" h="100dvh">
				<SimpleGrid
					spacing={{ base: 40, sm: 80 }}
					cols={{ base: 1, sm: 2 }}
					className={classes.grid_center}
				>
					<Image src={image} className={classes.mobileImage} />
					<div>
						<Title className={classes.title}>
							<Translate>
									No Internet Connection
							</Translate>
						</Title>
						<Text c="dimmed" size="lg">
							<Translate>
								No Internet connection found, Please check your connection and try again
							</Translate>
						</Text>
					</div>
					<Image src={image} className={classes.desktopImage} />
				</SimpleGrid>
			</Center>
		</Container>
  );
}

export default PageNoNetwork
